<template>
<v-app>
    <v-snackbar v-model="snackbar" top color="red" :timeout="4000">
        {{ errorMsg }}
        <v-btn color="white" icon @click="snackbar = false">
            <v-icon>mdi-close</v-icon>
        </v-btn>
    </v-snackbar>
    <v-container fluid class="mt-1">
        <v-card class="mx-10">
            <v-card-title>
                <v-img style="max-width: 250px" src="@/assets/logo-bmci.png"></v-img>
                <v-spacer></v-spacer>
                Offre "Auto Perfecto" Particuliers
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col>
                        <v-simple-table dense>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Durée</th>
                                        <th class="text-left">Mensualité TTC</th>
                                        <th class="text-left">Frais de dossier</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(offre,index) in offres" :key="index">
                                        <td class="text-right">{{offre.duration}}</td>
                                        <td class="text-right">{{FormatPrix(MonthlyPayement(montant,apport,offre.duration,offre.tx,offre.ty))}}</td>
                                        <td class="text-center" rowspan="6" v-if="index === 0">
                                            OFFERTS
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </v-container>
</v-app>
</template>

<script>
export default {
    name: "CreditParticuliers",
    data() {
        return {
            offres: [],
            snackbar: false,
            errorMsg: ''
        }
    },
    mounted() {
        this.getOffres()
    },
    methods: {
        getOffres: function () {
            let params = {}
            params.action = 'getOffres'
            params.type = 'bmci'
            params.name = 'creditparticuliers'
            this.axios.post(this.$store.state.rootUrl + 'apiSalesTarifier.php', params)
                .then(data => {
                    this.offres = data.data
                })
                .catch(error => {
                    this.errorMsg = 'Oups Erreur Serveur. Veuillez réessayer dans quelques instants'
                    this.snackbar = true
                    console.log(error)
                })
        },
        MonthlyPayement: function (amount, apport, months, rate, rate_) {
            let monthlyIntrestRate = rate / 1200
            let Monthly = (((amount - apport) * monthlyIntrestRate) / (1 - (Math.pow((1 + monthlyIntrestRate), months * -1)))) * (1 + (rate_ / 100));
            return Monthly.toFixed(2)
        },
        FormatPrix: function (prix) {
            return new Intl.NumberFormat('de-DE', {
                style: 'decimal',
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }).format(prix)
        }
    },
    computed: {
        montant() {
            return this.$store.state.simulateur.montant
        },
        selectedApport() {
            return this.$store.state.simulateur.selectedApport
        },
        apport() {
            return this.$store.state.simulateur.apport
        }
    }
}
</script>
